import dayjs from "dayjs";
import toast from "react-hot-toast";

import type { PaymentStatement } from "../app/services/paymentStatements";
import { downloadFile } from "./downloadFile";

/** 支払明細書 PDF のダウンロードファイル名（BE と同一形式）。 */
export const buildPaymentStatementFileName = (created: string): string =>
  `支払明細書_${dayjs(created).format("YYYYMMDD")}.pdf`;

/** 一覧行から PDF をダウンロードする。未生成時は toast を出して何もしない。 */
export const downloadPaymentStatementPdf = (
  statement: PaymentStatement,
  options?: { showMissingToast?: boolean },
): void => {
  if (!statement.pdf_url) {
    if (options?.showMissingToast) {
      toast.error("PDFがまだ生成されていません");
    }
    return;
  }
  downloadFile(
    statement.pdf_url,
    buildPaymentStatementFileName(statement.created),
  );
};
